import { render } from "./UploadErrorCard.vue?vue&type=template&id=a4af0466&ts=true"
import script from "./UploadErrorCard.vue?vue&type=script&lang=ts"
export * from "./UploadErrorCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__